import React from 'react';
import {withTranslation as withReactI18NextTranslation} from 'react-i18next';
import {isFunction, trim} from 'lodash';
import {constant} from 'lodash/fp';

import {asClassComponent} from '/util/hoc.util';

import {getPrefixedEffect, ts, tt} from './TranslationProvider.util';

const withTranslation = (keyPrefix: any) => (Component: any) => {
  const ComponentWithTranslation = withReactI18NextTranslation()(Component);

  const prefix = trim(keyPrefix);
  const ttWithPrefix = getPrefixedEffect(tt, prefix);

  return asClassComponent((props: any) => {
    return <ComponentWithTranslation {...props} tt={ttWithPrefix} ts={ts} />;
  });
};

withTranslation.tt = tt;

withTranslation.ts = ts;

// This function is strictly meant for components' `defaultProps`.
// Do not call this function to render translation string.
// Use `withTranslation.tt` or `withTranslation.ts` instead.
withTranslation.ttDefaultProp = (_: any, value: any) =>
  (isFunction(value) ? value : constant(value))();

// This function is strictly meant for components' `defaultProps`.
// Do not call this function to render translation string.
// Use `withTranslation.tt` or `withTranslation.ts` instead.
withTranslation.tsDefaultProp = (_: any, value: any) => constant(value);

export default withTranslation;
